import React,{ useEffect, useState, Fragment} from 'react';
import { Spinner, Modal, Button, Form, Alert } from "react-bootstrap";
import MyApiClient from '../../../api-client/MyApiClient';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Logout } from '../../../store/actions/AuthActions';
import StrutturaCalendarioEventi from './calendario/eventi';
import { segnalaMancanti } from '../../components/Util/campiMancanti';

// Soci e consiglio direttivo solo per le ASD (TASK #3, opzione B del 21/10/2026)
const eAsd = () => {
	try { return JSON.parse(sessionStorage.getItem('userDetails') || '{}').clubNature === 'ASD'; } catch { return false; }
};

const HomeStruttura = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [loadingShowed, setLoadingShowed] = useState(false);
	const [administrationClub, setAdministrationClub] = useState(null);
	//const [administrationClubSales, setAdministrationClubSales] = useState([]);
	//const [data_json, setDataJson] = useState([]);
	const [fitcoinGuadagnati, setFitcoinGuadagnati] = useState(0);
	const [fitcoinDisponibili, setFitcoinDisponibili] = useState(0);
	const [fitcoinSpesi, setFitcoinSpesi] = useState(0);

	const [showFiscalCodeModal, setShowFiscalCodeModal] = useState(false);
	const [taxCodeInput, setFiscalCodeInput] = useState('');
	const [taxCodeError, setFiscalCodeError] = useState('');
	const [profile, setProfile] = useState(null);

	// Banner onboarding dashboard: ricorda se l'utente lo ha già chiuso, anche nelle sessioni successive
	const [dashboardPopupDismissed, setDashboardPopupDismissed] = useState(
		localStorage.getItem('dashboardPopupDismissed') === 'true'
	);
	const handleCloseDashboardPopup = () => {
		setDashboardPopupDismissed(true);
		localStorage.setItem('dashboardPopupDismissed', 'true');
	};
	const handleReopenDashboardPopup = () => {
		setDashboardPopupDismissed(false);
		localStorage.removeItem('dashboardPopupDismissed');
	};

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
					const localId = tokenDetails.localId;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const [clubData, fitcoinData, profileData] = await Promise.all([
                        apiClient.getAdministrationClub(token),
                        apiClient.getWalletFitcoinsSummary(token,localId),
						apiClient.getProfile(token)
                    ]);
					setLoadingShowed(false);

					if (profileData) {
						setProfile(profileData);
						// Inserimento obbligatorio del Codice Fiscale al primo accesso
						// temporaneamente disattivato.
						// if (profileData.club && !profileData.club.taxCode) {
						// 	setShowFiscalCodeModal(true);
						// }
					}

					if(fitcoinData) {
						setFitcoinDisponibili(fitcoinData.balance);

						let fitcoinSpesi = 0;
						let fitcoinGuadagnati = 0;
						if (fitcoinData.transactions) {
							fitcoinData.transactions.forEach(transaction => {
								//const transactionId = transaction.transactionId;
								const type = transaction.type;
								const amount = transaction.amount;
								//const createdAt = transaction.createdAt;
								//const isMerchant = transaction.isMerchant;
								//const description = transaction.description;

								//const data = new Date(createdAt);
								//const options = { year: '2-digit', month: '2-digit', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };
								//const formattedDate = data.toLocaleDateString('it-IT', options);

								if(type==='EARN' && transaction.eventType !== 'FITBACK_REFUND') {
									fitcoinGuadagnati += amount;
								}

								if(type==='SPENT') {
									fitcoinSpesi += amount;
								}
							});
						}

						setFitcoinSpesi(fitcoinSpesi);
						setFitcoinGuadagnati(fitcoinGuadagnati);
					}

                    setAdministrationClub(clubData);
                    //setAdministrationClubSales(clubSalesData);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

	const handleSaveFiscalCode = async () => {
		if (!taxCodeInput) {
			segnalaMancanti([{ campo: 'dashboard-codice-fiscale', messaggio: 'Manca il codice fiscale' }]);
			return;
		}
		
		 let isValid = false;
		 const cfRegex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
		 
		 if (taxCodeInput.length === 16 && cfRegex.test(taxCodeInput)) {
			 isValid = true;
		 } else if (taxCodeInput.length === 11 && !isNaN(taxCodeInput)) {
			 isValid = true;
		 }

		 if (!isValid) {
			 segnalaMancanti([{ campo: 'dashboard-codice-fiscale', messaggio: 'Controlla il formato del codice fiscale (16 caratteri) o della partita IVA (11 cifre)' }]);
			 return;
		 }

		try {
			setLoadingShowed(true);
			const tokenDetailsString = sessionStorage.getItem('userDetails');
			const tokenDetails = JSON.parse(tokenDetailsString);
			const token = tokenDetails.idToken;
			const apiClient = new MyApiClient();

			let profile_send = JSON.parse(JSON.stringify(profile));
			if(!profile_send.club) profile_send.club = {};
			profile_send.club.taxCode = taxCodeInput;
			
			if (profile_send.club.logo) delete profile_send.club.logo;
			if (profile_send.club.pictures) delete profile_send.club.pictures;

			const result = await apiClient.updateProfile(token, profile_send);
			setLoadingShowed(false);

			if (result && result.error) {
				 setFiscalCodeError('Errore durante il salvataggio: ' + result.error);
			} else {
				 setShowFiscalCodeModal(false);
				 window.location.reload();
			}
		} catch (e) {
			setLoadingShowed(false);
			setFiscalCodeError('Errore imprevisto');
		}
	}

	/*
	const data_column = [
        {
            Header: 'Prodotto',
            accessor: 'name',
            Filter: ColumnFilter
        },
        {
            Header: 'Quantità',
            accessor: 'quantity',
			Filter: ColumnFilter
        },
        {
            Header: 'Vendite nette',
            accessor: 'totalSalesSum',
			Filter: ColumnFilter
		}
    ];
	*/

	return(
		<>
		<Modal className="fade" show={loadingShowed} centered>
			<Modal.Body className="text-center">
			<Spinner animation="border" role="status">
				<span className="sr-only">Loading...</span>
			</Spinner>
			<div>Caricamento in corso...</div>
			</Modal.Body>
		</Modal>

		<Modal show={showFiscalCodeModal} backdrop="static" keyboard={false} centered>
			<Modal.Header>
				<Modal.Title>Codice Fiscale Mancante</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>È necessario inserire il Codice Fiscale della struttura per procedere.</p>
				<Form.Group>
					<Form.Label htmlFor="dashboard-codice-fiscale">Codice Fiscale *</Form.Label>
					<Form.Control 
						id="dashboard-codice-fiscale"
						type="text" 
						value={taxCodeInput} 
						onChange={(e) => {
							setFiscalCodeInput(e.target.value.toUpperCase());
							setFiscalCodeError('');
						}}
						isInvalid={!!taxCodeError}
					/>
					<Form.Control.Feedback type="invalid">
						{taxCodeError}
					</Form.Control.Feedback>
				</Form.Group>
			</Modal.Body>
			<Modal.Footer className="justify-content-center">
				<Button variant="danger" onClick={() => dispatch(Logout(navigate))}>
					Esci
				</Button>
				<Button variant="primary" onClick={handleSaveFiscalCode}>
					Salva e Continua
				</Button>
			</Modal.Footer>
		</Modal>

		{/* KPI — riga unica compatta (4 conteggi + 3 FitCoin), allineata al design-system */}
		<div className="sid-kpi-row sid-dash-kpi">
			<div className="sid-kpi">
				<div className="sid-kpi-label">Player</div>
				<div className="sid-kpi-value">{ administrationClub!=null ? administrationClub.clients : 0 }</div>
			</div>
			<div className="sid-kpi">
				<div className="sid-kpi-label">Junior</div>
				<div className="sid-kpi-value">{ administrationClub!=null ? administrationClub.juniors : 0 }</div>
			</div>
			{eAsd() && (
			<div className="sid-kpi">
				<div className="sid-kpi-label">Soci</div>
				<div className="sid-kpi-value">{ administrationClub!=null ? administrationClub.members : 0 }</div>
			</div>
			)}
			<div className="sid-kpi">
				<div className="sid-kpi-label">Staff tecnico</div>
				<div className="sid-kpi-value">{ administrationClub!=null ? administrationClub.coaches : 0 }</div>
			</div>
			<div className="sid-kpi coin gray">
				<div className="sid-kpi-label">FitCoin guadagnati</div>
				<div className="sid-kpi-value-row"><span className="sid-kpi-value">{fitcoinGuadagnati}</span></div>
			</div>
			<div className="sid-kpi coin green">
				<div className="sid-kpi-label">FitCoin disponibili</div>
				<div className="sid-kpi-value-row"><span className="sid-kpi-value">{fitcoinDisponibili}</span></div>
			</div>
			<div className="sid-kpi coin danger">
				<div className="sid-kpi-label">FitCoin spesi</div>
				<div className="sid-kpi-value-row"><span className="sid-kpi-value">{fitcoinSpesi}</span></div>
			</div>
		</div>

		{/* Alert fatturazione + banner onboarding — sotto le KPI, stessa larghezza */}
		{profile?.club?.invoiceDataSender?.status === 'WAIT_RESPONSE' && (
			<Alert variant="warning" className='solid' style={{color: 'black'}}>
				<strong>Attenzione!</strong> La tua richiesta di attivazione della fatturazione è in attesa di approvazione da parte dell'amministrazione. Puoi comunque modificare i dati se necessario nel <a href="/struttura/lamiastruttura?tab=fatturazione" style={{textDecoration: 'underline'}}>tab fatturazione</a>.
			</Alert>
		)}
		{profile?.club?.invoiceDataSender?.status === 'REJECTED' && (
			<Alert variant="danger" className='solid'>
				<strong>Attenzione!</strong> La tua richiesta attuale di attivazione della fatturazione è stata rifiutata, modifica i dati nel <a href="/struttura/lamiastruttura?tab=fatturazione" style={{textDecoration: 'underline', color: 'white'}}>tab fatturazione</a> e invia una nuova richiesta per l'approvazione.
				{profile.club.invoiceDataSender.rejectionMessage && (
					<div className="mt-2">
						<strong>Motivo:</strong> {profile.club.invoiceDataSender.rejectionMessage}
					</div>
				)}
			</Alert>
		)}
		{profile?.club?.profileStatus !== 'INACTIVE' && !dashboardPopupDismissed && (
			<div className="card" style={{ backgroundColor: '#28a745', color: '#fff' }}>
				<div className="card-header border-0 flex-wrap flex-column align-content-start align-items-baseline" style={{ position: 'relative', padding: '10px' }}>
					<button
						onClick={handleCloseDashboardPopup}
						aria-label="Chiudi"
						style={{
							position: 'absolute',
							right: '12px',
							top: '12px',
							background: 'transparent',
							border: 'none',
							color: '#fff',
							fontSize: '20px',
							lineHeight: 1,
							cursor: 'pointer'
						}}
					>
						×
					</button>
					<div>
						<p className="mb-2">Adesso, per sfruttare al meglio SportId Manager® ti consigliamo di:</p>
						<ol className="mb-3" style={{ paddingLeft: '20px' }}>
							<li className="mb-2">
								1) Invitare tutti i tuoi atleti e dirigenti a scaricare e utilizzare SportId® Player.
								Puoi utilizzare la funzione aggiungi player che trovi nel menù di sinistra: anagrafiche - player - aggiungi player o puoi inviare
								il messaggio WhatsApp che trovi nel menù di sinistra sotto la voce "kit comunicazione".
							</li>
							<li className="mb-2">
								2) Invitare tutti i tuoi maestri/allenatori a utilizzare SportId® Player e poi invitarli a scaricare e accedere,
								con le stesse credenziali create su SportId® Player, a SportId Coach®.
								Trovi il messaggio WhatsApp nel menù principale di sinistra sotto la voce "kit comunicazione".
							</li>
							<li className="mb-2">3) Creare i tuoi abbonamenti.</li>
							<li className="mb-2">4) Creare i tuoi corsi.</li>
							<li className="mb-2">
								5) Affiggere all'interno della tua struttura la locandina A3 che trovi sempre nel menù principale di sinistra sotto la voce "kit comunicazione".
							</li>
						</ol>
						<p className="mb-0">
							Se riscontri problemi, segui le nostre wiki cliccando qui:
							<a href="https://www.sportid.it/impara-utilizzare-sportid/" target="_blank" rel="noopener noreferrer" className="text-white" style={{ textDecoration: 'underline', marginLeft: '5px' }}>
								www.sportid.it/impara-utilizzare-sportid/
							</a>
						</p>
					</div>
				</div>
			</div>
		)}

		{profile?.club?.profileStatus !== 'INACTIVE' && dashboardPopupDismissed && (
			<div
				onClick={handleReopenDashboardPopup}
				role="button"
				tabIndex={0}
				title="Mostra i consigli per iniziare"
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: '8px',
					backgroundColor: '#28a745',
					color: '#fff',
					borderRadius: '8px',
					padding: '8px 14px',
					cursor: 'pointer',
					fontSize: '13px'
				}}
			>
				<i className="fa fa-info-circle" aria-hidden="true"></i>
				Consigli per iniziare a usare SportId Manager®
			</div>
		)}

		<div className="mt-4">
			<StrutturaCalendarioEventi />
		</div>

		</>
	)
}
export default HomeStruttura;